import useToken from 'hooks/useToken';
import { useParams, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';

import ConfirmationModal from '../facturas-emitidas/lista-facturas/ConfirmationModal';
import ModalRegistrarFacturaComoGasto from './visualizacion-factura/ModalRegistrarFacturaComoGasto';

// Importing reusable components from facturas-emitidas
import DatosFactura from '../facturas-emitidas/visualizacion-factura/DatosFactura';
import ConceptosFactura from '../facturas-emitidas/visualizacion-factura/ConceptosFactura';
import CondicionesPago from '../facturas-emitidas/visualizacion-factura/CondicionesPago';
import SellosDigitales from '../facturas-emitidas/visualizacion-factura/SellosDigitales';
import TablaConciliaciones from '../TablaConciliaciones';
import BotonesAccionRecibidas from './visualizacion-factura/BotonesAccionRecibidas';
import HeaderFacturaRecibida from './visualizacion-factura/HeaderFacturaRecibida';
import DocumentosRelacionados from '../facturas-emitidas/visualizacion-factura/DocumentosRelacionados';
import PagosRelacionados from '../facturas-emitidas/visualizacion-factura/PagosRelacionados';

const VisualizacionFacturasRecibidas = () => {

    const { showErrorToast, showSuccessToast } = useToast();
    const navigate = useNavigate();

    const { token, setToken } = useToken();
    const { id } = useParams();

    const [receptor, setReceptor] = useState({});
    const [emisor, setEmisor] = useState({});
    const [facturaElectronica, setFacturaElectronica] = useState({});
    const [datosSellos, setDatosSellos] = useState({});
    const [conceptos, setConceptos] = useState([]);
    const [total, setTotal] = useState({});
    const [value, setValue] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);
    const [isActive, setIsActive] = useState(null)
    const [idGasto, setIdGasto] = useState(null);

    const [showGastoModal, setShowGastoModal] = useState(false);
    const [documentosRelacionados, setDocumentosRelacionados] = useState([]);
    const [pagosRelacionados, setPagosRelacionados] = useState([]);
    const [dMontoConciliado, setDMontoConciliado] = useState(0);
    const [dTotalDB, setDTotalDB] = useState(0);
    const [conciliaciones, setConciliaciones] = useState([]);

    useEffect(() => {
        ObtenerXML();
        ObtenerPagos();
    }, [id]);

    const ObtenerPagos = async () => {
        var objDataSend = { idFacturaRecibida: id };
        const response = await fetch("/api/contabilidad/centro-xml/FacturasRecibidas/ObtenerPagosRelacionados", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objDataSend)
        }).catch((error) => console.log('Fetch error:', error));

        if (response && response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles || '[]');
                setPagosRelacionados(ObjDetalles);
            }
        }
    };

    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }; ""


    const ObtenerXML = async () => {

        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        console.log("Informacion enviada al endpoint", objDataSend)
        const response = await fetch("/api/contabilidad/centro-xml/FacturasRecibidas/obtenerXMLFacturaRecibida",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            console.log("==== informacion Factura  ====");
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);


            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                console.log(ObjDetalles, "detalles")

                setIsActive(ObjDetalles.table2[0].bIsActive)
                setIdGasto(ObjDetalles.table2[0].idGasto || null);
                setDMontoConciliado(ObjDetalles.table2[0].dMontoConciliado || 0);
                setDTotalDB(ObjDetalles.table2[0].dTotal || 0);
                
                // Extraer conciliaciones
                setConciliaciones(ObjDetalles.table3 || ObjDetalles.Table2 || ObjDetalles.table1 || []);

                let vXMLString = ObjDetalles.table2[0].vXML;
                let vXML = JSON.parse(vXMLString);
                console.log(vXML)

                let emisorA = vXML.Comprobante.Emisor;

                let emisor = ObjDetalles.table2[0].vRegimenFiscalEmisor;

                setEmisor({ ...emisorA, ...emisor, vRegimenFiscalEmisor: emisor });
                let receptor = vXML.Comprobante.Receptor;

                let comprobante = vXML.Comprobante;



                let complemento = vXML.Comprobante.Complemento.timbreFiscalDigital;
                const tfd = vXML.Comprobante.Complemento.timbreFiscalDigital;
                const cadenaOriginal = `||${tfd.version}|${tfd.UUID}|${tfd.FechaTimbrado}|${tfd.RfcProvCertif}|${tfd.SelloCFD}|${tfd.NoCertificadoSAT}||`;


                const cfdiRelacionados = vXML.Comprobante.CfdiRelacionados;
                setDocumentosRelacionados(cfdiRelacionados ? (Array.isArray(cfdiRelacionados) ? cfdiRelacionados : [cfdiRelacionados]) : []);


                let productos = vXML.Comprobante.Conceptos.Concepto;



                setConceptos(productos);




                /***************/
                /*Cuenta total factura*/
                /***************/

                let total = vXML.Comprobante.Total || 0;
                let subtotal = vXML.Comprobante.SubTotal || 0;

                let tasaOCuota = vXML.Comprobante.Impuestos?.Traslados?.Traslado?.[0]?.TasaOCuota || 0;
                let descuento = vXML.Comprobante.Descuento || null;



                /*let total = vXML.Comprobante.Impuestos.Traslados.Traslado[0];*/
                let traslados2 = vXML.Comprobante.Impuestos?.TotalImpuestosTrasladados || 0;
                let retenidos = vXML.Comprobante.Impuestos?.TotalImpuestosRetenidos || 0;




                /***************/
                /*TRASLADOS/
                /***************/
                let traslados = vXML.Comprobante.Impuestos?.Traslados?.Traslado;

                let TrasladoISR = null;
                let TrasladoIVA = null;
                let tieneIvaExento = false;

                if (Array.isArray(traslados)) {
                    traslados.forEach((tras) => {
                        if (tras.TipoFactor === 'Exento' && tras.Impuesto === '002') tieneIvaExento = true;
                        switch (tras.Impuesto) {
                            case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(tras.Importe || 0); break;
                            case '002': if (tras.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(tras.Importe || 0); break;
                        }
                    });
                } else if (traslados) {
                    if (traslados.TipoFactor === 'Exento' && traslados.Impuesto === '002') tieneIvaExento = true;
                    switch (traslados.Impuesto) {
                        case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(traslados.Importe || 0); break;
                        case '002': if (traslados.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(traslados.Importe || 0); break;
                    }
                }



                /***************/
                /*RETENCIONES/
                /***************/

                let retenciones = vXML.Comprobante.Impuestos?.Retenciones?.Retencion;

                let RetencionIVA = 0;
                let RetencionISR = 0;
                let RetencionIEPS = 0;

                if (Array.isArray(retenciones)) {
                    retenciones.forEach((ret) => {
                        switch (ret.Impuesto) {
                            case '001': RetencionISR += parseFloat(ret.Importe || 0); break;
                            case '002': RetencionIVA += parseFloat(ret.Importe || 0); break;
                            case '003': RetencionIEPS += parseFloat(ret.Importe || 0); break;
                        }
                    });
                } else if (retenciones) {
                    switch (retenciones.Impuesto) {
                        case '001': RetencionISR += parseFloat(retenciones.Importe || 0); break;
                        case '002': RetencionIVA += parseFloat(retenciones.Importe || 0); break;
                        case '003': RetencionIEPS += parseFloat(retenciones.Importe || 0); break;
                    }
                }

                // Formateo de los valores a formato con comas y puntos
                let formattedTotal = formatNumberMX(total);
                let formattedSubtotal = formatNumberMX(subtotal);
                let formattedTraslados = traslados ? formatNumberMX(traslados2) : null;
                let formattedTasaOCuota = formatNumberMX(tasaOCuota);
                let formattedDescuento = descuento > 0 ? formatNumberMX(descuento) : null;
                let formattedRetenidos = retenidos ? formatNumberMX(retenidos) : null;
                // Almacenar los valores formateados
                setTotal({
                    dTotal: formattedTotal,
                    dTotalSinFormato: total,
                    dSubtotal: formattedSubtotal,
                    dtrasladosImpuestos: formattedTraslados,
                    TasaOCuota: formattedTasaOCuota,
                    TasaOCuotaOriginal: tasaOCuota,
                    Descuento: formattedDescuento,
                    Retenidos: formattedRetenidos,
                    RetencionIVA: RetencionIVA ? formatNumberMX(RetencionIVA) : null,
                    RetencionISR: RetencionISR ? formatNumberMX(RetencionISR) : null,
                    RetencionIEPS: RetencionIEPS ? formatNumberMX(RetencionIEPS) : null,
                    TrasladoIVA: TrasladoIVA !== null ? formatNumberMX(TrasladoIVA) : null,
                    TrasladoISR: TrasladoISR !== null ? formatNumberMX(TrasladoISR) : null,
                    tieneIvaExento: tieneIvaExento
                });

                // cuando parseas y extraes del XML:
                setFacturaElectronica({
                    TipoDeComprobante: comprobante.TipoDeComprobante === "I"
                        ? 'I - Ingreso'
                        : comprobante.TipoDeComprobante === "E"
                            ? 'E - Egreso'
                            : 'P - Pago',
                    MetodoPago: comprobante.MetodoPago === "PUE" ? 'PUE - Pago en una sola exhibición' : 'PDD - Pago en parcialidades ',
                    FormaPago: ObjDetalles.table2[0].vClave,
                    Moneda: comprobante.Moneda,
                    LugarExpedicion: comprobante.LugarExpedicion,
                    Fecha: comprobante.Fecha,
                    Exportacion: comprobante.Exportacion === "01" ? '01 - No Aplica' : '',
                    CertificadoEmisor: comprobante.NoCertificado,
                    Serie: comprobante.Serie,
                    Folio: comprobante.Folio,
                    TipoDeCambio: comprobante.TipoCambio,
                    CondicionesDePago: comprobante.CondicionesDePago

                });





                setReceptor({
                    ...vXML.Comprobante.Receptor,
                    vUsoCFDI: ObjDetalles.table2[0].vUsoCfdi,
                    vRegimen: ObjDetalles.table2[0].vRegimenFiscal,
                    NumRegIdTrib: comprobante.Receptor.NumRegIdTrib,
                    ResidenciaFiscal: comprobante.Receptor.ResidenciaFiscal,
                    DomicilioFiscal: comprobante.Receptor.DomicilioFiscalReceptor

                });



                // cuando parseas y extraes del XML:
                setDatosSellos({
                    FechaTimbrado: complemento.FechaTimbrado,
                    NoCertificadoSAT: complemento.NoCertificadoSAT,
                    RfcProvCertif: complemento.RfcProvCertif,
                    SelloCFD: complemento.SelloCFD,
                    SelloSAT: complemento.SelloSAT,
                    UUID: complemento.UUID,
                    version: complemento.version,
                    certificacionSat: cadenaOriginal
                });



                let last8 = complemento.SelloCFD.slice(-8);

                setValue(`https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id=${complemento.UUID}&re=${emisorA.Rfc}&rr=${receptor.Rfc}&tt=${total}&fe=${last8}`);





            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";

            }

        }
    };



    const handleOpenModal = (action) => {
        setCurrentAction(action);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentAction(null);
    };


    const handleConfirmAction = async () => {
        try {
            if (currentAction === 'eliminar') {
                await eliminarFactura();
            } else if (currentAction === 'cancelar') {
                await cancelarFactura();
            }
        } catch (error) {
            console.error(`Error al ${currentAction} la factura:`, error);
        }
    };

    const eliminarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        const response = await fetch("/api/contabilidad/centro-xml/FacturasRecibidas/EliminaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });



        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                navigate("/contabilidad/centro-xml/facturas-recibidas");


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const cancelarFactura = async () => {
        var objDataSend = {};
        objDataSend.idFacturaRecibida = id;

        const response = await fetch("/api/contabilidad/centro-xml/FacturasRecibidas/CancelaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    body: JSON.stringify(objDataSend)
                },
                body: JSON.stringify(objDataSend)

            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                setIsActive(false);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const handleOpenGastoModal = () => {
        setShowGastoModal(true);
    };

    const handleCloseGastoModal = () => {
        setShowGastoModal(false);
    };

    const handleGastoSuccess = (mensaje) => {
        showSuccessToast(mensaje);
        ObtenerXML();
    };

    const handleGastoError = (mensaje) => {
        showErrorToast(mensaje);
    };


    return (
        <>
            <Card>
                <Container className="py-4">
                    <HeaderFacturaRecibida
                        isActive={isActive}
                        idFactura={parseInt(id)}
                        vUUIDFactura={datosSellos?.UUID}
                        dFechaEmision={facturaElectronica?.Fecha}
                        vRfcEmisor={receptor?.Rfc}
                        dMontoConciliado={dMontoConciliado}
                        dTotal={dTotalDB}
                    />

                    <DatosFactura
                        emisor={emisor}
                        receptor={receptor}
                        facturaElectronica={facturaElectronica}
                    />

                    <DocumentosRelacionados documentos={documentosRelacionados} tipoFactura="recibida" />

                    <PagosRelacionados pagos={pagosRelacionados} totalFactura={total?.dTotalSinFormato} tipoFactura="recibida" />

                    <CondicionesPago facturaElectronica={facturaElectronica} />

                    <ConceptosFactura
                        conceptos={conceptos}
                        total={total}
                        facturaElectronica={facturaElectronica}
                    />

                    <SellosDigitales
                        datosSellos={datosSellos}
                        value={value}
                    />

                    <TablaConciliaciones conciliaciones={conciliaciones} />

                    <BotonesAccionRecibidas
                        TipoDeComprobante={facturaElectronica.TipoDeComprobante}
                        isActive={isActive}
                        handleOpenModal={handleOpenModal}
                        handleOpenGastoModal={handleOpenGastoModal}
                        idGasto={idGasto}
                        datosSellos={datosSellos}
                        emisor={emisor}
                        receptor={receptor}
                        total={total?.dTotal || null}
                    />
                </Container>
            </Card>

            <ConfirmationModal
                show={showModal}
                onHide={handleCloseModal}
                onConfirm={handleConfirmAction}
                action={currentAction}
                IsActive={isActive}
            />

            <ModalRegistrarFacturaComoGasto
                show={showGastoModal}
                onHide={handleCloseGastoModal}
                idFacturaRecibida={id}
                onSuccess={handleGastoSuccess}
                onError={handleGastoError}
            />
        </>
    );
}



export default VisualizacionFacturasRecibidas;